module.exports = __webpack_public_path__ + "static/media/Plymouth-Pointe-Bylaws.feb78e7f.pdf";